import {
  GET_INFO_INICIO,
  EDITAR_INICIO
} from "../../types";

export default (state, action) => {
  switch (action.type) {
    case GET_INFO_INICIO:
      return {
        ...state,
        slider: action.payload.slider,
        section1: action.payload.section1,
        banner: action.payload.banner,
      };
    case EDITAR_INICIO:
      return {
        ...state,
        slider: JSON.parse(action.payload.slider),
        section1: JSON.parse(action.payload.section1),
        banner: JSON.parse(action.payload.banner),
      };
    default:
      return state;
  }
};
